'user strict'
require('babel-polyfill');
const ex = require('../lib/error')
const moment = require('moment')
const Sequelize = require('../config/db')
const { or, where } = require('sequelize')
const urlShortner = require("../services/urlShortner")
const invoices = require('../models').invoices
const users = require('../models').users
const masterItems = require('../models').masterItems
const measurements = require('../models').measurements
const customers = require('../models').customers
const sequelize = require('sequelize')
const Op = sequelize.Op
let path = require('path');
const excel = require('exceljs')
const uploadFile = require('../services/uploadFile')
const { Console } = require('console');
const fs = require('fs');
const ejs = require("../services/ejs");
const invoiceBillPath = path.join(__dirname , "../../server/views/invoices/");

function currentTime() {
  const currDate = new Date();
  var hours = currDate.getHours();
  var minutes = currDate.getMinutes();
  var seconds = currDate.getSeconds();

  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return [hours, minutes, seconds];
}

const createInvoice = (req, res, next) => {

  if(!req.body) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");

  } else if(!req.body.userid) {
    ex.raiseError(req, res, "userid is required to create invoice", 400, "userid is required to create invoice");
    
  } else if(!req.body.items) {
    ex.raiseError(req, res, "items are required to create invoice", 400, "items are required to create invoice");  
  
  } else {
    const [hours, minutes, seconds] = currentTime();
    req.body.invoiceDate = new Date(req.body.invoiceDate).setUTCHours(hours, minutes, seconds);
    invoices.create(req.body)
      .then(invoice => {
  
        req.responseObject.data.invoice = invoice
  
        next()
      })
      .catch(error => {
        let errCode
        if (error.name === 'SequelizeUniqueConstraintError') {
          errCode = 'MAUD003'
        } else {
          errCode = 'MAUD004'
        }
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

const getLastNonGSTInvoiceNumber = (req, res, next) => {
  if(!req.body || !req.body.userid) {
    ex.raiseError(req, res, "userid is required", 400, "userid is required");

  } else {
    let where = { userid: req.body.userid, gstType: "", is_active: 1 }
    invoices
      .findAll({
        attributes: ['nonGstBillNo'],
        where: where, 
        group: ['nonGstBillNo'],
        order: [['nonGstBillNo', 'ASC']]
      })
      .then(invoices => {
        const billNos = [];
        invoices.forEach(invoice => {
          billNos.push(invoice.dataValues.nonGstBillNo)
        });
        req.responseObject.messageCode = 'OVA005'
        if (billNos.length != 0)
          req.responseObject.data.nonGstBillNo = billNos;
        else
          req.responseObject.data.nonGstBillNo = [0];
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

const getLastGSTInvoiceNumber = (req, res, next) => {
  let where = { userid: req.params.userid, gstType: { [Op.not]: "" }, is_active: 1 }
  invoices
    .findAll({
      attributes: ['gstBillNo'],
        where: where, 
        group: ['gstBillNo'],
        order: [['gstBillNo', 'ASC']]
    })
    .then(invoices => {
      const billNos = [];
      invoices.forEach(invoice => {
        billNos.push(invoice.dataValues.gstBillNo)
      });
      req.responseObject.messageCode = 'OVA005'
      if (billNos.length != 0)
        req.responseObject.data.gstBillNo = billNos;
      else
        req.responseObject.data.gstBillNo = [0];
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const uploadInvoicePdf = async (req, res, next) => {
  if (req.files && req.files.file && req.files.file.size > 0) {
    if (req.files.file.size > (15 * 1024 * 1024)) {
      flag = 1;
      ex.raiseError(req, res, 'MAUD006', 400, "max file size : 15 mb");
    }
    const filePath = req.files.file.path;
    const invoicePath = req.files.file.path.replace('\\', '/')
    const destPath = "billpdfs/" + invoicePath.substring(invoicePath.lastIndexOf('/') + 1)

    let publicUrl = uploadFile(filePath, destPath)
    publicUrl = await Promise.all([publicUrl])
    req.body.pdfLink = publicUrl[0];
    fs.unlinkSync(filePath);
    next()
  } else {
    next()
  }
}

const updateInvoice = (req, res, next) => {

  if (req.body.hasOwnProperty("invoiceDate")) {
    const [hours, minutes, seconds] = currentTime();
    req.body.invoiceDate = new Date(req.body.invoiceDate).setUTCHours(hours, minutes, seconds);
  }


  invoices
    .update(req.body, {
      where: { id: req.params.id },
      returning: true
    })
    .then(invoice => {
      req.responseObject.messageCode = 'OVA005'
      invoice = req.body;

      if (req.body.pdfLink != null)
        invoice.pdfLink = req.body.pdfLink;

      // to add userId and invoiceid to each item in next step
      req.responseObject.data.invoice = invoice
      req.responseObject.data.invoice.id = req.params.id;
      next()
    })
    .catch(error => {
      ex.raiseError(req, res, 'OVA008', 500, error)
    })
}

const getInvociesWithDate = (req, res, next) => {

  if(!req.body) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");

  } else if(!req.body.startDate || !req.body.endDate) {
    ex.raiseError(req, res, "startDate and endDate are required", 400, "startDate and endDate are required");

  } else {

    let endDate = new Date(req.body.endDate);
    var startedDate = new Date(req.body.startDate);
    startedDate.setUTCHours(0);
    endDate.setUTCHours(23, 59);
    let where = {
      userid: req.params.userid, is_active: true,
      invoiceDate: {
        [Op.gte]: startedDate,
        [Op.lte]: endDate
      }
    }
    invoices
      .findAll({
        where: where, order: [['invoiceDate', 'DESC']]
      })
      .then(invoices => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data.invoices = invoices
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

const getInvoicesWithDateForExport = (req, res, next) => {
  let endDateFromReq = (moment(req.body.endDate)).format('YYYY-MM-DD');
  const startedDate = new Date(req.body.startDate).setUTCHours(0);
  const endDate = new Date(endDateFromReq).setUTCHours(23, 59);
  req.body.startDate = startedDate;
  req.body.endDate = endDate;
  let where = {
    userid: req.params.userid,
    invoiceDate: {
      [Op.between]: [startedDate, endDate]
    },
    is_active: 1
  }
  
  invoices.hasMany(masterItems, { foreignKey: 'invoiceid' })
  masterItems.belongsTo(invoices, { foreignKey: 'invoiceid' })
  invoices.belongsTo(customers, { foreignKey: 'customerid'})
  invoices
    .findAll({
      where: where, include: [{
        required: false,
        model: masterItems,
        where: {
          is_active: 1
        }
      }, {
        required: false,
        model: customers
      }], order: [['invoiceDate', 'DESC']]
    })
    .then(invoices => {
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.invoices = invoices
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const generateXls = async (req, res, next) => {
  const workbook = new excel.Workbook();
  const summary = workbook.addWorksheet('Summary');
  const expenses = workbook.addWorksheet('Expenses');
  const bills = workbook.addWorksheet('Bills');
  const billproducts = workbook.addWorksheet('Bill Products');

  const A = 'A'
  const B = 'B'
  const C = 'C'
  const D = 'D'
  const E = 'E'
  const F = 'F'
  const G = 'G'
  const H = 'H'
  const I = 'I'
  const J = 'J'
  const K = 'K'
  const L = 'L'
  const M = 'M'
  const N = 'N'
  const O = 'O'
  const P = 'P'
  const Q = 'Q'
  const R = 'R'
  const S = 'S'



  let rowNo = 1
  let expRowNo = 1
  summary.getCell(A + rowNo).value = "Description "
  summary.getCell(B + rowNo).value = "Invoice Amount"
  summary.getCell(C + rowNo).value = "Expense"
  summary.getCell(D + rowNo).value = "Date"


  expenses.getCell(A + rowNo).value = "Description"
  expenses.getCell(B + rowNo).value = "Expense"
  expenses.getCell(C + rowNo).value = "Date"
  expRowNo++
  rowNo++
  let total = 0;

  req.responseObject.data.invoices.forEach((invoice, position) => {
    summary.getCell(A + rowNo).value = "Invoice " + invoice.id
    summary.getCell(B + rowNo).font = {
      color: { argb: '00ff00' },
    };
    summary.getCell(B + rowNo).value = invoice.totalAfterDiscount ? invoice.totalAfterDiscount : invoice.totalAmount;
    summary.getCell(D + rowNo).value = moment(invoice.invoiceDate).format("DD/MM/YYYY");

    total = total + (invoice.totalAfterDiscount ? invoice.totalAfterDiscount : invoice.totalAmount);
    rowNo++
  });
  req.responseObject.data.expenseList.forEach((expense, position) => {
    summary.getCell(A + rowNo).value = expense.name
    summary.getCell(C + rowNo).font = {
      color: { argb: 'ff0000' },
    };
    summary.getCell(C + rowNo).value = ('-') + expense.amount
    summary.getCell(D + rowNo).value = moment(expense.expenseDate).format("DD/MM/YYYY");

    expenses.getCell(A + expRowNo).value = expense.name
    expenses.getCell(B + expRowNo).value = expense.amount
    expenses.getCell(C + expRowNo).value = moment(expense.expenseDate).format("DD/MM/YYYY");

    rowNo++
    expRowNo++
    total = total - expense.amount
  });
  summary.getCell(A + rowNo).font = {
    color: { argb: '000000' },
    bold: true
  };
  summary.getCell(A + rowNo).value = "Profit"


  summary.getCell(B + rowNo).font = {
    color: { argb: total < 0 ? 'ff0000' : '00ff00' },
    bold: true
  };
  summary.getCell(B + rowNo).value = total

  rowNo = 1;

  bills.getCell(A + rowNo).value = "Bill"
  bills.getCell(B + rowNo).value = "Date"
  bills.getCell(C + rowNo).value = "Customer Name"
  bills.getCell(D + rowNo).value = "Mobile no"
  bills.getCell(E + rowNo).value = "Address"
  bills.getCell(F + rowNo).value = "Customer GSTNo"
  bills.getCell(G + rowNo).value = "Total Amount Before Discount"
  bills.getCell(H + rowNo).value = "Discount"
  bills.getCell(I + rowNo).value = "Total Amount After Discount"
  bills.getCell(J + rowNo).value = "Status"

  rowNo++

  req.responseObject.data.invoices.forEach(invoice => {
      bills.getCell(A + rowNo).value = invoice.gstType ? invoice.gstBillNo : invoice.nonGstBillNo
      bills.getCell(B + rowNo).value = moment(invoice.invoiceDate).format("DD/MM/YYYY")
      bills.getCell(C + rowNo).value = invoice.customer.name
      bills.getCell(D + rowNo).value = invoice.customer.mobileNo
      bills.getCell(E + rowNo).value = invoice.customer.address
      bills.getCell(F + rowNo).value = invoice.GSTNo
      bills.getCell(G + rowNo).value = invoice.totalAmount
      bills.getCell(H + rowNo).value = invoice.discount
      bills.getCell(I + rowNo).value = invoice.totalAfterDiscount
      bills.getCell(J + rowNo).value = invoice.is_active ? "Active" : "Cancelled"
      rowNo++
  })



  rowNo = 1;
  let where = {
    userid: req.params.userid,
    invoiceDate: {
      [Op.between]: [req.body.startDate, req.body.endDate]
    },
    gstBillNo: {
      [Op.gt]: 0
    }
  }

  var checkgst = 0;

  await invoices
    .findAll({
      where: where
    }).then(invoices => {
      if (invoices.length > 0) {
        checkgst = 1;
      }
    }).catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })

  billproducts.getCell(A + rowNo).value = "Bill No "
  billproducts.getCell(B + rowNo).value = "Date"
  billproducts.getCell(C + rowNo).value = "Item Name"
  billproducts.getCell(D + rowNo).value = "Price Including GST"
  if (checkgst == 0) {
    billproducts.getCell(E + rowNo).value = "Quantity"
    billproducts.getCell(F + rowNo).value = "TotalAmount"
    billproducts.getCell(G + rowNo).value = "IMEI/Serial Number"
    billproducts.getCell(H + rowNo).value = "Status"
  } else {
    billproducts.getCell(E + rowNo).value = "GST%"
    billproducts.getCell(F + rowNo).value = "Quantity"
    billproducts.getCell(G + rowNo).value = "Amount Before GST"
    billproducts.getCell(H + rowNo).value = "SGST Amount"
    billproducts.getCell(I + rowNo).value = "CGST Amount"
    billproducts.getCell(J + rowNo).value = "IGST Amount"
    billproducts.getCell(K + rowNo).value = "TotalAmount"
    billproducts.getCell(L + rowNo).value = "IMEI/Serial Number"
    billproducts.getCell(M + rowNo).value = "HSN Code"
    billproducts.getCell(N + rowNo).value = "Status"
  }

  rowNo++

  req.responseObject.data.invoices.forEach(invoice => {
    invoice.masterItems.forEach(item => {
      billproducts.getCell(A + rowNo).value = invoice.gstType ? invoice.gstBillNo : invoice.nonGstBillNo
      billproducts.getCell(B + rowNo).value = moment(invoice.invoiceDate).format("DD/MM/YYYY")
      billproducts.getCell(C + rowNo).value = item.name
      billproducts.getCell(D + rowNo).value = item.price
      if (checkgst == 0) {
        billproducts.getCell(E + rowNo).value = item.quantity
        billproducts.getCell(F + rowNo).value = item.totalAmount
        billproducts.getCell(G + rowNo).value = item.imei
        billproducts.getCell(H + rowNo).value = invoice.is_active ? "Active" : "Cancelled"
      } else {
        const gstAmt = item.totalAmount - item.gstAmount
        billproducts.getCell(E + rowNo).value = item.gst
        billproducts.getCell(F + rowNo).value = item.quantity
        billproducts.getCell(G + rowNo).value = item.gstAmount
        billproducts.getCell(H + rowNo).value = (item.gstType == "CGST/SGST (Local customer)" ? gstAmt / 2 : 0)
        billproducts.getCell(I + rowNo).value = (item.gstType == "CGST/SGST (Local customer)" ? gstAmt / 2 : 0)
        billproducts.getCell(J + rowNo).value = (item.gstType == "IGST (Central/outstation customer)" ? gstAmt : 0)
        billproducts.getCell(K + rowNo).value = item.totalAmount
        billproducts.getCell(L + rowNo).value = item.imei
        billproducts.getCell(M + rowNo).value = item.serial_no
        billproducts.getCell(N + rowNo).value = invoice.is_active ? "Active" : "Cancelled"
      }
      rowNo++
    })
  });
  const fileName = "Daybook_" + new Date().getTime() + ".xlsx"
  workbook.xlsx.writeFile(__dirname + '/../../public/daybooks/' + fileName)
  req.responseObject.data.dayBookLink = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/daybooks/" + fileName
  if (!(req.body.email == "" || !(req.body.hasOwnProperty('email')))) {
    req.responseObject.data.mailOption = {
      to: req.body.email,
      subject: "Day Book Report", // Subject line
      text: "Please find the attched day book report in xls", // 
      attachments: [
        {   // utf-8 string as an attachment
          filename: fileName,
          path: __dirname + '/../../public/daybooks/' + fileName // stream this file
        },
      ]
    }
  }
  next()
}

const searchInvoice = (req, res, next) => {
  if(!req.body) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");

  } else if(!req.body.userid) {
    ex.raiseError(req, res, "userid is required", 400, "userid is required");

  } else if(!req.body.page) {
    ex.raiseError(req, res, "page is required", 400, "page is required");

  } else {
    let limit = 100
    let offset = req.body.page * limit - limit
    let whereCustomer = {
      
    }
    let whereDefault = {
      userid: req.body.userid,
      is_active: true
    }
    if (req.body.customerMobileNo != null && req.body.customerMobileNo.length > 0) {
      whereCustomer =
        Sequelize.and({
          userid: req.body.userid
        }, Sequelize.or({ mobileNo: { [Op.like]: "%" + req.body.customerMobileNo + "%" } },
          {
            $and: sequelize.where(
              Sequelize.fn('lower', Sequelize.col('customer.name')),
              {
                [Op.like]: "%" + req.body.customerMobileNo.toLowerCase() + "%"
              }
            )
          }))
    }
    if (req.body.startDate != null && req.body.endDate != null) {
      // from time 00:00:00 of startDate to 23:59:59 of endDate
      const startDate = new Date(req.body.startDate).getTime() + 19800000;
      const endDate = new Date(req.body.endDate).getTime() + 106199000;

      whereDefault.invoiceDate = {
        [Op.between]: [startDate, endDate]
      }
    }
    invoices.hasMany(masterItems, { foreignKey: 'invoiceid' })
    masterItems.belongsTo(invoices, { foreignKey: 'invoiceid' })
    invoices.belongsTo(customers, { foreignKey: 'customerid'})
    invoices
      .findAndCountAll({
        where: whereDefault, include: [{
          required: false,
          model: masterItems,
          where: { is_active: true }
        }, {
          required: true,
          model: customers,
          where:whereCustomer
        }
      ], order: [['invoiceDate', 'DESC']], offset: offset, limit: limit, distinct: true
      })
      .then(invoices => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data.invoices = invoices
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
    }
}

const updateInvoiceInCancelProcess = (req, res, next) => {

}

const getInvoiceDetails = (req, res, next) => {

  let where = { id: req.params.id }
  invoices.hasMany(masterItems, { foreignKey: 'invoiceid' })
  masterItems.belongsTo(invoices, { foreignKey: 'invoiceid' })
  invoices.belongsTo(customers, { foreignKey: 'customerid'})

  invoices
    .findOne({
      where: where, include: [{
        required: false,
        model: masterItems,
        where: { is_active: true },
      },
      {
        required: false,
        model: customers,
      }
    ]
    })
    .then(invoice => {
      req.responseObject.data.invoice = invoice
      req.responseObject.messageCode = 'OVA005'
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const checkCancelStatus = (req, res, next) => {
  if (req.body.items.length > 0) {
    req.responseObject.data.is_active = false;
  } else {
    req.responseObject.data.is_active = false;
  }
  next()
}

const getInvoicesForExport = (req, res, next) => {
  let where = {
    createdAt: {
      [Op.between]: [moment(req.query.start), moment(req.query.end).add(1, 'day')]
    }
  }
  invoices.hasMany(masterItems, { foreignKey: 'invoiceid' })
  invoices.belongsTo(users, { foreignKey: 'userid' })
  masterItems.belongsTo(measurements, { foreignKey: 'measurementId' })
  masterItems.belongsTo(invoices, { foreignKey: 'invoiceid' })
  invoices.belongsTo(customers, { foreignKey: 'customerid'})

  try {
    compareDate(req.query.start, req.query.end)
    function compareDate(StartDate, EndDate) {
      const start = new Date(StartDate)
      const end = new Date(EndDate)

      if (!(start < end)) {
        throw new Error('Invalid Dates');
      }
    }
  } catch (error) {
    ex.raiseError(req, res, 400, 400, error)
  }

  invoices
    .findAll({
      where: where, include: [{
        required: true,
        model: masterItems,
        include: [{
          model: measurements,
          required: false
        }]
      },
    {
      required: true,
      model: users
    },
    {
      required: false,
      model: customers
    }], order: [['invoiceDate', 'DESC']]
    })
    .then(invoices => {
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.invoices = invoices
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const generateXlsForExport = (req, res, next) => {
  const fileName = "Invoices_" + new Date().getTime() + ".xlsx";
  const filePath = __dirname + '/../../public/invoices/' + fileName;
  let options = {
    filename: filePath,
  };
  
  const workbook = new excel.stream.xlsx.WorkbookWriter(options);
  const invoices = workbook.addWorksheet('Invoices');
  const invoiceProductDetail = workbook.addWorksheet('Invoice Product Details');
  invoices.columns = [
    { header: 'Bill No', key: 'billNo' },
    { header: 'Date', key: 'date' },
    { header: 'Customer Name', key: 'customerName' },
    { header: 'Mobile no', key: 'mobileNo' },
    { header: 'Address', key: 'address' },
    { header: 'Customer GSTNo', key: 'customerGSTNo' },
    { header: 'Total Amount Before Discount', key:'totalAmount' },
    { header: 'Discount', key: 'discount' },
    { header: 'Total Amount After Discount', key:'totalAfterDiscount' },
    { header: 'Status', key:'status' },
    { header: 'RetailerID', key:'retailerID' },
    { header: 'InvoiceID', key:'invoiceID' },
    { header: 'Create Date', key:'createDate' },
    { header: 'Modified Date', key:'modifiedDate' },
    { header: 'shopName', key:'shopName' },
    { header: 'shopAddr', key:'shopAddr' },
    { header: 'mobileNo', key:'mobileNo' },
    { header: 'state', key:'state' },
    { header: 'city', key: 'city' },
    { header: 'pincode', key: 'pincode' },
    { header: 'gstNo', key: 'gstNo' },
    { header: 'email', key: 'email' },
    { header: 'fulllname', key: 'fulllname' },
    { header: 'registrationDate', key: 'createdAt'},
  ];

  invoiceProductDetail.columns = [
    { header: 'Bill No', key: 'billNo' },
    { header: 'Date', key: 'date' },
    { header: 'Item Name', key: 'itemName' },
    { header: 'Price Including GST', key: 'priceIncludingGST' },
    { header: 'GST%', key: 'GSTp' },
    { header: 'Quantity', key: 'quantity' },
    { header: 'Amount Before GST', key: 'amountBeforeGST' },
    { header: 'SGST Amount', key: 'SGSTAmount' },
    { header: 'CGST Amount', key:'CGSTAmount' },
    { header: 'IGST Amount', key:'IGSTAmount' },
    { header: 'TotalAmount', key: 'totalAmount' },
    { header: 'IMEI/Serial Number', key:'IMEI' },
    { header: 'HSN Code', key:'HSNCode' },
    { header: 'Status', key:'status' },
    { header: 'RetailerID', key:'retailerID' },
    { header: 'InvoiceID', key:'invoiceID' },
    { header: 'Create Date', key:'createDate' },
    { header: 'Modified Date', key:'modifiedDate' },
    { header: 'shopName', key:'shopName' },
    { header: 'shopAddr', key:'shopAddr' },
    { header: 'mobileNo', key:'mobileNo' },
    { header: 'state', key:'state' },
    { header: 'city', key: 'city' },
    { header: 'pincode', key: 'pincode' },
    { header: 'gstNo', key: 'gstNo' },
    { header: 'email', key: 'email' },
    { header: 'fulllname', key: 'fulllname' },
    { header: 'registrationDate', key: 'createdAt'},
  ];
   
  req.responseObject.data.invoices.forEach(invoice => {
    invoice.masterItems.forEach(item => {      
      const gstAmt = item.totalAmount - item.gstAmount;
      invoices.addRow({
        billNo: invoice.gstType.length ? invoice.gstBillNo : invoice.nonGstBillNo,
        date: invoice.invoiceDate,
        customerName: invoice.customer.name,
        mobileNo: invoice.customer.mobileNo,
        address: invoice.customer.address,
        customerGSTNo: invoice.GSTNo,
        totalAmount: item.totalAmount,
        discount: invoice.discount,
        totalAfterDiscount: invoice.totalAfterDiscount,
        status: invoice.is_active ? "Active" : "Cancelled",
        retailerID: invoice.userid,
        invoiceID: invoice.id,
        createDate: invoice.createdAt,
        modifiedDate: invoice.updatedAt,
        shopName: invoice.user.shopName,
        shopAddr: invoice.user.shopAddr,
        mobileNo:invoice.user.mobileNo,
        state :invoice.user.state,
        city: invoice.user.city,
        pincode :invoice.user.pincode,
        gstNo: invoice.user.gstNo,
        emial: invoice.user.emial,
        fulllname: invoice.user.fulllname,
        createdAt: invoice.user.createdAt,
      }).commit();

      invoiceProductDetail.addRow({
        billNo: invoice.gstType.length ? invoice.gstBillNo : invoice.nonGstBillNo,
        date: invoice.invoiceDate,
        itemName: item.name,
        priceIncludingGST: item.price,
        GSTp: item.gst,
        quantity: item.quantity,
        amountBeforeGST: item.gstAmount,
        SGSTAmount: item.gstType == "" ? 0 : (item.gstType == "CGST/SGST (Local customer)" ? gstAmt / 2 : 0),
        CGSTAmount: item.gstType == "" ? 0 : (item.gstType == "CGST/SGST (Local customer)" ? gstAmt / 2 : 0),
        IGSTAmount: item.gstType == "" ? 0 : (item.gstType == "IGST (Central/outstation customer)" ? gstAmt : 0),
        totalAmount: item.totalAmount,
        IMEI: item.imei,
        HSNCode: item.serial_no,
        status: invoice.is_active ? "Active" : "Cancelled",
        retailerID: invoice.userid,
        invoiceID: invoice.id,
        createDate: invoice.createdAt,
        modifiedDate: invoice.updatedAt,
        shopName: invoice.user.shopName,
        shopAddr: invoice.user.shopAddr,
        mobileNo:invoice.user.mobileNo,
        state :invoice.user.state,
        city: invoice.user.city,
        pincode :invoice.user.pincode,
        gstNo: invoice.user.gstNo,
        emial: invoice.user.emial,
        fulllname: invoice.user.fulllname,
        createdAt: invoice.user.createdAt,
      }).commit();
    })
  });

  workbook.commit();
  req.responseObject.data = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/invoices/" + fileName;
  next();
}

const getMeasurements = (req, res, next) => {
  measurements
    .findAll()
    .then(measurements => {
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.invoices = measurements
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const getInvoiceUrl = (req, res, next) => {
  invoices
    .findOne({
      where: {
        id: req.params.invoiceid
      }
    }).then(async invoice => {
      if (invoice.pdfLink === null || invoice.pdfLink === "") {
        req.responseObject.pdfLink = "";
      }
      else {
        let shortUrl = await urlShortner(invoice.pdfLink);
        if (shortUrl.body.url.status !== 7) {
          req.responseObject.data.pdfLink = invoice.pdfLink
        }
        else {
          req.responseObject.data.pdfLink = shortUrl.body.url.shortLink;
        }
      }
      next()
    }).catch(error => {
      console.log(error);
      ex.raiseError(req, res, 'OVA006', 500, error)
    })
}

const searchItems = (req, res, next) => {
  if(!req.body || !req.body.name || !req.body.userid) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");

  } else {
  
    let name = req.body.name.toLowerCase();
    let limit = 5;
    let where = {
      userid: req.body.userid,
      $and: sequelize.where(
        Sequelize.fn('lower', Sequelize.col('name')),
        {
          [Op.like]: `%${name}%`
        }
      )
    }
    masterItems
      .findAll({
        attributes: [[Sequelize.fn('lower', Sequelize.col('name')), 'name']],
        group: [Sequelize.fn('lower', Sequelize.col('name'))],
        where: where, limit: limit, distinct: true
      }).then(items => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data.items = items
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

const searchMeasurementId = (req, res, next) => {
  if(!req.body || !req.body.name || !req.body.userid) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");

  } else {

    let name = req.body.name;
    name = name.toLowerCase(name);
    let limit = 1;
    let where = {
      userid: req.body.userid,
      $and: sequelize.where(
        Sequelize.fn('lower', Sequelize.col('name')),
        {
          [Op.like]: `${name}`
        }
      )
    }
    masterItems
      .findAll({
        attributes: ['measurementId', 'updatedAt'],
        order: [['updatedAt', 'DESC']],
        where: where, limit: limit
      }).then(ids => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data.items = ids
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

const checkInvoiceNumber = (req, res, next) => {

  if(!req.body || !req.body.hasOwnProperty('billNo') || !req.body.hasOwnProperty('gst') || !req.body.userid) {
    ex.raiseError(req, res, "Invalid request", 400, "Invalid request");
  } else {

    const where = {
      userid: req.body.userid,
      is_active: true
    }
    const billType = req.body.gst ? 'gstBillNo' : 'nonGstBillNo';
    where[`${billType}`] = req.body.billNo;

    invoices.findAll({
      attributes: ["id"],
      where
    })
      .then(invoices => {
        if(invoices.length === 0) {
          req.responseObject.data = true;
        } else {
          req.responseObject.data = false;
        }
        next();
      })
      .catch(error => {
        ex.raiseError(req, res, error.name, 500, error);
      })
  }
}

const createInvoicePdf = async (req, res, next) => {
try{
  if(req.body.is_active != false){
    let body = req.body;
  let longBill1Path = invoiceBillPath + "longBill1.ejs";
  let shortBill1Path = invoiceBillPath + "shortBill1.ejs";
  let user = await users.findOne({ 
    where: {
      userid : req.body.userid
    }
  });
  let customer = req.responseObject.customer;
  delete req.responseObject.customer;
  body['user'] = user;
  body['customer'] = customer;
  let longHtml1 = await ejs.toHTML(longBill1Path,body);
  let shortHtml1 = await ejs.toHTML(shortBill1Path, body)
  req.responseObject.data['shortHtml1'] = shortHtml1;
  req.responseObject.data['longHtml1'] = longHtml1;
  let destination = 'billpdfs/'+"longBill_" + req.body.userid + "_" + Date.now();
  let pdfUrl = await uploadFile.pdfGen(longHtml1,'A4',destination);
  req.body['pdfLink'] = pdfUrl;
  next();
  } else {
    next();
  }
} catch (err){
  ex.raiseError(req, res, err.name, 500, err);
}
}

const deleteInvoicesInBulk = (req, res, next) => {
  try {
    if(!req.body.invoiceIDs) {
      ex.raiseError(req, res, "Invoice IDs are mandatory", 400, "Specify Invoice IDs to delete");
    } else {
      const invoiceIDs = req.body.invoiceIDs;
      invoices.update({
        'is_active': false
      },
      {
        where: {id: invoiceIDs}
      }).then(result => {
        req.responseObject.data = "Invoices Marked Deleted";
        next();
      }).catch(err => {
        ex.raiseError(req, res, err.name, 500, err);
      });
    }
  } catch(err) {
    ex.raiseError(req, res, err.name, 500, err);
  }
}

module.exports = {
  createInvoice,
  // getInvocies,
  getLastNonGSTInvoiceNumber,
  getLastGSTInvoiceNumber,
  uploadInvoicePdf,
  updateInvoice,
  getInvociesWithDate,
  getInvoicesWithDateForExport,
  generateXls,
  searchInvoice,
  updateInvoiceInCancelProcess,
  getInvoiceDetails,
  checkCancelStatus,
  getInvoicesForExport,
  generateXlsForExport,
  getMeasurements,
  getInvoiceUrl,
  searchItems,
  searchMeasurementId,
  checkInvoiceNumber,
  createInvoicePdf,
  deleteInvoicesInBulk
}
